export const invoicesTypes = {
  CLEAR_INVOICES: "CLEAR_INVOICES",
  SET_INPUTS: "SET_INPUTS",
  GET_INVOICES: "GET_INVOICES",
  CANCEL_INVOICE: "CANCEL_INVOICE",
  SUBSTITUTE_INVOICE: "SUBSTITUTE_INVOICE",
  SET_EMAIL_INVOICE: "SET_EMAIL_INVOICE",
  SELECT_INVOICE_ID: "SELECT_INVOICE_ID",
  SET_FORM_CANCEL_INVOICE: "SET_FORM_CANCEL_INVOICE",
  SET_FORM_SUBSTITUTE_INVOICE: "SET_FORM_SUBSTITUTE_INVOICE",
  UPDATE_FILES_INVOICE: "UPDATE_FILES_INVOICE",
  CHECK_NOTE_MIGRATIONS: "CHECK_NOTE_MIGRATIONS",
  RESTORE_INITIAL: "RESTORE_INITIAL",
};
